// The routes this module owns, as the app mounts them. `route.ts` takes its mount from here and
// `src/app/paths.ts` merges this into the one `paths` object, so a link and a route cannot drift.
type Id = string | number | undefined;

export const waapPaths = {
  base: '/services/waap',
  onboarding: '/services/waap/onboarding',
  /** One WAAP service (its console root). */
  service: (serviceId: Id) => `/services/waap/${serviceId}`,
} as const;
